let config = require("../config.js");
let COLORS = require("../data/colors.js");
let UTILS = require("./utils.js");
let THREE = require("three");
let overlay = {};
var U;
let canvas = (overlay.canvas = document.getElementById("game-overlay"));
function resize() {
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
}
window.addEventListener("resize", resize);
resize();
let flashImage = new Image();
let flashLoaded = false;
flashImage.onload = () => (flashLoaded = true);
flashImage.src = "./img/muzflash.png";
overlay.updateMuzzle = function (ap) {
  flashLoaded = false;
  flashImage.onload = () => (flashLoaded = true);
  flashImage.src = ap;
};
let Z = new Image();
let a0 = false;
Z.onload = () => (a0 = true);
Z.src = "./img/infect_0.png";
let objectiveMarkerImage = new Image();
let objectiveMarkerLoaded = false;
objectiveMarkerImage.onload = () => (objectiveMarkerLoaded = true);
objectiveMarkerImage.src = UTILS.assetsUrl("/textures/objective_1.png");
overlay.bloodCustom = false;
overlay.bloodOpacity = 0;
overlay.bloodImage = new Image();
overlay.bloodLoaded = false;
overlay.bloodImage.onload = () => (overlay.bloodLoaded = true);
overlay.bloodImage.src = "./img/blood.png";
let a3 = [
  {
    loaded: false,
    image: new Image(),
  },
  {
    loaded: false,
    image: new Image(),
  },
];
a3[0].image.onload = () => (a3[0].loaded = true);
a3[0].image.src = UTILS.assetsUrl("/textures/flag_r.png");
a3[1].image.onload = () => (a3[1].loaded = true);
a3[1].image.src = UTILS.assetsUrl("/textures/flag_b.png");
let a4 = {
  vic: {},
  dra: {},
  def: {},
};
Object.keys(a4).forEach((ap) => {
  let aq = a4[ap];
  aq.img = new Image();
  aq.loaded = false;
  aq.img.onload = () => (aq.loaded = true);
  aq.img.src = "./img/" + ap + ".png";
});
let a5 = new Image();
let a6 = false;
a5.onload = () => (a6 = true);
a5.src = "./img/medal.svg";
[
  {
    name: "nuke",
  },
].forEach((ap) => {
  ap.img = new Image();
  ap.loaded = false;
  ap.img.onload = () => (ap.loaded = true);
  ap.img.src = "./img/medals/" + ap.name + ".png";
});
var a7 = null;
overlay.kpdData = null;
overlay.hideNames = false;
overlay.showDMG = true;
overlay.dmgNums = [];
overlay.showFlash = false;
overlay.flashX = 0;
overlay.flashY = 0;
overlay.fakeCross = false;
overlay.crosshairType = 1;
overlay.dmgColor = "white";
overlay.critColor = "white";
overlay.crosshairColor = "white";
overlay.crosshairShadow = "black";
overlay.crosshairShadowThickness = 1;
overlay.crosshairOpacity = 0;
overlay.crosshairUseOpacityCustom = false;
overlay.crosshairOpacityCustom = 0;
overlay.crosshairScale = 0;
overlay.crosshairAlways = false;
overlay.dynamicHP = true;
overlay.dmgScale = 30;
overlay.crosshairStyle = 1;
overlay.crosshairThick = 2;
overlay.crosshairLen = 16;
overlay.crosshairGap = 0;
overlay.crosshairDot = false;
overlay.crosshairImage = new Image();
overlay.nametagStyle = 0;
overlay.nametagOpacity = 1;
overlay.healthNum = false;
overlay.healthColT = COLORS.teams[0];
overlay.healthColE = COLORS.teams[1];
overlay.scopeBorders = true;
overlay.divs = [];
overlay.scoreText = {
  color: "#ffea78",
  text: "",
  opacity: 0,
  textAlign: "center",
  top: 37,
  left: 50,
  display: false,
};
overlay.checkText = {
  color: "#40C4FF",
  text: "",
  opacity: 0,
  textAlign: "center",
  top: 20,
  left: 50,
  display: false,
};
overlay.chalName = {
  color: "#fff",
  text: "",
  text2: "",
  fontSize: 80,
  width: 517,
  height: 167,
  lineHeight: 150,
  opacity: 0,
  textAlign: "center",
  top: "40px",
  left: 50,
  display: false,
  rect: {
    color: null,
  },
};
overlay.vicTitle = {
  type: "vic",
  show: false,
  opacity: {
    val: 0,
    increment: 0.05,
  },
  scale: {
    val: 2.5,
    decrement: 0.005,
    acc: 0.01,
  },
};
overlay.medals = [];
overlay.medalPrefab = {
  margin: 40,
  x: canvas.width / 2,
  y: canvas.height / 2,
  size: 200,
  border: 7,
  offset: -5,
  opacity: {
    increment: 0.05,
  },
  zoom: {
    val: 1.2,
    increment: 0.01,
  },
  delay: 5000,
};
overlay.hitmarker = {
  image: null,
  loaded: false,
  opacity: 0,
  width: 105,
  height: 105,
  display: false,
  custom: false,
};
var a8 = {};
function a9(ap, aq, ar, as, at, au, av) {
  let aw = ap.createLinearGradient(
    aq,
    ar,
    aq + (au == "X" ? as : 0),
    ar + (au == "Y" ? at : 0),
  );
  av.forEach((ax, ay) => aw.addColorStop(ay, ax));
  ap.fillStyle = aw;
  ap.fillRect(aq, ar, as, at);
}
function aa(ap) {
  return ap.slice(0, -1) + String.fromCharCode(65 + UTILS.randInt(0, 5));
}
overlay.hitSet = {
  enabled: true,
  opacity: 1,
};
overlay.showHit = function (ap) {
  if (overlay.hitSet.enabled) {
    a8.active = true;
    a8.opacity = overlay.hitSet.opacity;
    a8.spacing = overlay.hitSet.spacing;
    a8.inc = overlay.hitSet.inc;
    a8.length = ap ? overlay.hitSet.length * 1.2 : overlay.hitSet.length;
    a8.colors = ap ? overlay.hitSet.kColors : overlay.hitSet.colors;
  }
};
var ab = 0;
var ac = 0;
overlay.speedDisplay = {
  color: "#ffea78",
  colorMax: "#ff0000",
  curr: 0,
  max: 0,
  display: false,
  fontSize: 24,
  opacity: 1,
  top: 54,
  left: 50,
  update: 0,
};
overlay.reset = function () {
  for (var ap = 0; ap < overlay.divs.length; ++ap) {
    overlay.divs[ap].display = false;
  }
  overlay.divs.length = 0;
};
overlay.animateText = function (ap, aq, ar, as, at, au, av, aw) {
  if (overlay.divs.indexOf(ap) < 0) {
    overlay.divs.push(ap);
  }
  ap.delay = av;
  if (!av) {
    ap.display = true;
  }
  ap.fontSize = ar;
  ap.scale = ar;
  ap.minScale = as ? ar * 0.4 : ar;
  ap.text = aq;
  ap.scaleSpeed = as;
  ap.life = at;
  ap.fade = au;
  ap.opacity = 1;
  ap.callback = aw;
};
overlay.animateDiv = function (ap, aq, ar, as, at, au, av, aw, ax) {
  if (overlay.divs.indexOf(ap) < 0) {
    overlay.divs.push(ap);
  }
  ap.delay = aw;
  if (!aw) {
    ap.display = true;
  }
  ap.fontSize = as;
  ap.scale = as;
  ap.minScale = at ? as * 0.4 : as;
  ap.text = aq.toUpperCase();
  ap.text2 = ar ? ar.toUpperCase() : null;
  ap.scaleSpeed = at;
  ap.life = au;
  ap.fade = av;
  ap.opacity = 1;
  ap.callback = ax;
};
overlay.animateNewMedal = function (ap, aq, ar, as) {
  if (overlay.medals.indexOf(ap) < 0) {
    overlay.medals.push(ap);
  }
  ap.name = aq;
  ap.score = ar;
  ap.callback = as;
};
overlay.animateDiv = function (ap, aq, ar, as, at) {
  if (overlay.divs.indexOf(ap) < 0) {
    overlay.divs.push(ap);
  }
  ap.display = true;
  ap.life = aq;
  ap.maxLife = aq;
  ap.opacity = 1;
  ap.fade = ar;
  if (as) {
    ap.width = as;
    ap.height = as;
    ap.startS = as;
    ap.scaleSpd = at;
  }
};
overlay.dmgVal = function (ap, aq, ar, as, at) {
  if (overlay.showDMG) {
    a7 = null;
    for (var au = 0; au < overlay.dmgNums.length; ++au) {
      if (!overlay.dmgNums[au].life) {
        a7 = overlay.dmgNums[au];
        break;
      }
    }
    if (!a7) {
      a7 = {};
      overlay.dmgNums.push(a7);
    }
    a7.crit = at;
    a7.life = 1000;
    a7.x = ap;
    a7.y = aq + 7;
    a7.z = ar;
    a7.dir = UTILS.randFloat(-Math.PI, Math.PI);
    a7.val = as;
  }
};
var ad = [];
Number.prototype.map = function (ap, aq, ar, as) {
  return ((this - ap) * (as - ar)) / (aq - ap) + ar;
};
function ae() {
  this.life = 0;
  this.init = function (ap, aq, ar, as) {
    this.x = ap;
    this.y = aq;
    this.speed = ar.map(0, 400, 2, 8);
    this.life = this.startLife = UTILS.randInt(500, 1100);
    this.alpha =
      UTILS.randFloat(
        Math.max(0, overlay.shoSpdLines - 0.4),
        overlay.shoSpdLines,
      ) * Math.min(1, (ar - 50) / 50);
    this.angle = Math.PI * UTILS.randFloat(0, 2);
    this.size = ar.map(0, 350, 1, 400);
    this.inRadius = ar.map(0, 400, 550, 350);
    this.outRadius = as;
  };
  this.update = function (ap, aq) {
    this.life -= this.speed * aq;
    this.inRadius += this.speed * aq;
    this.alpha *= this.life / this.startLife;
    this.size *= this.life / this.startLife;
    this.render(ap);
  };
  this.render = function (ap) {
    ap.save(1);
    ap.translate(this.x, this.y);
    ap.rotate(this.angle);
    ap.beginPath();
    ap.moveTo(0, this.inRadius);
    ap.lineTo(this.size, this.outRadius);
    ap.lineTo(-this.size, this.outRadius);
    ap.closePath();
    ap.fillStyle = "rgba(" + overlay.spdLinesCol + ", " + this.alpha + ")";
    ap.fill();
    ap.restore();
  };
}
overlay.shoSpdLines = 0;
overlay.spdLinesCol = "230,230,230";
for (var af = 0; af < 15; ++af) {
  ad.push(new ae());
}
overlay.drawMinimap = false;
var ag = 0;
var ah = 0;
var ai = ["volume_down", "volume_up"];
var pos = new THREE.Vector3();
var ctx = canvas.getContext("2d");
var al = ctx.createLinearGradient(
  0 - overlay.chalName.width / 2,
  0,
  overlay.chalName.width / 2,
  0,
);
function am(ap, aq, ar, as, at) {
  if (!(as <= 0)) {
    ap.save(1);
    ap.globalAlpha = as;
    var au = ap.createLinearGradient(0 - aq / 2, 0, aq / 2, 0);
    au.addColorStop(0.85, "rgba(0,0,0,0)");
    au.addColorStop(0.85, "rgba(" + overlay.hitColor + ",0.8)");
    au.addColorStop(1, "rgba(" + overlay.hitColor + ",0)");
    ap.fillStyle = au;
    ap.rotate(((at || 0) * Math.PI) / 180);
    ap.fillRect(0 - aq / 2, 0 - ar / 2, aq, ar);
    ap.restore();
  }
}
function an(ap, aq, ar, as, at, au = 1, av = false, aw = true, ax = true) {
  if (aw) {
    ap.save(1);
    if (ax) {
      ap.fillStyle = overlay.crosshairShadow;
    } else {
      ap.strokeStyle = overlay.crosshairShadow;
    }
    ap.lineWidth = au;
    ap.globalAlpha *= 0.5;
    ap.beginPath();
    if (av) {
      ap.ellipse(
        aq + as / 2,
        ar + at / 2,
        as / 2 + 2,
        at / 2 + 2,
        0,
        0,
        Math.PI * 2,
      );
    } else {
      ap.rect(aq - 2, ar - 2, as + 4, at + 4);
    }
    if (ax) {
      ap.fill();
    } else {
      ap.stroke();
    }
    ap.restore();
  }
  if (ax) {
    ap.fillStyle = overlay.crosshairColor;
  } else {
    ap.strokeStyle = overlay.crosshairColor;
  }
  ap.lineWidth = au;
  ap.beginPath();
  if (av) {
    ap.ellipse(aq + as / 2, ar + at / 2, as / 2, at / 2, 0, 0, Math.PI * 2);
  } else {
    ap.rect(aq, ar, as, at);
  }
  if (ax) {
    ap.fill();
  } else {
    ap.stroke();
  }
}
al.addColorStop(0, "rgba(0,0,0,0)");
al.addColorStop(0.4, "rgba(0,0,0,0.3)");
al.addColorStop(0.6, "rgba(0,0,0,0.3)");
al.addColorStop(1, "rgba(0,0,0,0)");
overlay.chalName.rect.color = al;
overlay.hits = [];
overlay.showHits = true;
overlay.hitColor = "255,63,63";
overlay.rainbow = {
  col: "#ffffff",
  val: 0,
  freq: 1000 / 60,
  upd: 0,
};
overlay.render = function (scale, Game, CONTROLS, RENDER, player, deltaMs, unscaledDeltaMs, voiceStreamQueues) {
  let OVERLAY = overlay;
  let ay = canvas.width / scale;
  let az = canvas.height / scale;
  let aA = endUI.style.display != "none" || menuHolder.style.display != "none";
  let aB = killCardHolder.style.display == "none" && !aA;
  var aCVector = new THREE.Vector3();
  let aC = RENDER.camera.getWorldPosition(aCVector);
  var aD = player && player.team ? player.team : window.spectating ? 1 : 0;
  if ((ah -= deltaMs) <= 0) {
    ah = 300;
    if (++ag >= ai.length) {
      ag = 0;
    }
  }
  ctx.save(1);
  ctx.scale(scale, scale);
  ctx.clearRect(0, 0, ay, az);
  (function (aR, aS, aT, aU, aV) {
    if (overlay.shoSpdLines && aR && aR.active) {
      var aW = UTILS.distance2D(0, 0, aR.velX, aR.velZ) * 500;
      if (aW >= 50) {
        for (var aX = 0; aX < ad.length; ++aX) {
          if (ad[aX].life <= 0) {
            ad[aX].init(aT / 2, aU / 2, aW, aT);
          } else {
            ad[aX].update(aS, aV);
          }
        }
      }
    }
  })(player, ctx, ay, az, deltaMs);
  if (overlay.showHits) {
    ctx.save(1);
    ctx.translate(ay / 2, az / 2);
    if (player && player.active) {
      for (var aE = 0; aE < OVERLAY.hits.length; ++aE) {
        if (OVERLAY.hits[aE].life) {
          OVERLAY.hits[aE].life -= deltaMs;
          if (OVERLAY.hits[aE].life <= 0) {
            OVERLAY.hits[aE].life = 0;
          }
          am(
            ctx,
            az / 2,
            83,
            OVERLAY.hits[aE].life / config.hitLife,
            THREE.Math.radToDeg(
              UTILS.direction2D(
                OVERLAY.hits[aE].x,
                OVERLAY.hits[aE].z,
                player.x,
                player.z,
              ) + CONTROLS.xDr,
            ),
          );
        }
      }
    }
    ctx.restore();
  }
  if (overlay.showDMG) {
    for (aE = 0; aE < overlay.dmgNums.length; ++aE) {
      if ((U = overlay.dmgNums[aE]).life) {
        U.life -= deltaMs;
        if (U.life <= 0) {
          U.life = 0;
        } else {
          U.y += deltaMs * 0.022;
          U.x += deltaMs * 0.013 * Math.cos(U.dir);
          U.z += deltaMs * 0.013 * Math.sin(U.dir);
          pos.set(U.x, U.y, U.z);
          if (!RENDER.frustum.containsPoint(pos)) {
            continue;
          }
          ctx.save(1);
          pos.project(RENDER.camera);
          pos.x = (pos.x + 1) / 2;
          pos.y = (pos.y + 1) / 2;
          ctx.translate(Math.round(ay * pos.x), Math.round(az * (1 - pos.y)));
          ctx.fillStyle = U.crit ? overlay.critColor : overlay.dmgColor;
          ctx.strokeStyle = "#2e2e2e";
          ctx.lineWidth = 5;
          ctx.font = overlay.dmgScale + "px GameFont";
          var aF = -Math.round(ctx.measureText(U.val).width / 2);
          ctx.strokeText(U.val, aF + 1, 0);
          ctx.fillText(U.val, aF, 0);
          ctx.restore();
        }
      }
    }
  }
  if (!aA) {
    for (aE = 0; aE < Game.AI.ais.length; ++aE) {
      if (
        !(U = Game.AI.ais[aE]).active ||
        !U.canBSeen ||
        !U.mesh ||
        !U.mesh.visible
      ) {
        continue;
      }
      if (!U.alwaysName && U.health && U.health == U.maxHealth) {
        continue;
      }
      var aG = 1 + U.scale / 30;
      (aM = U.mesh.position.clone()).y += U.scale * 2 + config.nameOffset + 1.5;
      if (
        !(aJ =
          (aO = Math.max(
            0.3,
            1 - UTILS.getD3D(aC.x, aC.y, aC.z, aM.x, aM.y, aM.z) / 600,
          )) *
            20 >=
            1 && RENDER.frustum.containsPoint(aM))
      ) {
        continue;
      }
      ctx.save(1);
      aM.project(RENDER.camera);
      aM.x = (aM.x + 1) / 2;
      aM.y = (aM.y + 1) / 2;
      ctx.translate(ay * aM.x, az * (1 - aM.y));
      ctx.scale(aO, aO);
      let aR = U.name;
      let aS = aG * 20 + "px GameFont";
      ctx.font = aS;
      let aT = ctx.measureText(aR).width;
      let aU = aG * 120;
      let aV = (1 + (aG - 1) * 0.3) * 16;
      if (U.maxHealth) {
        ctx.fillStyle = "rgba(0,0,0,0.4)";
        ctx.fillRect(-aU / 2, -aV, aU, aV);
        ctx.fillStyle = OVERLAY.healthColE;
        ctx.fillRect(-aU / 2, -aV, aU * (U.health / U.maxHealth), aV);
      }
      ctx.translate(-aT / 2, -aV - aG * 7);
      ctx.fillStyle = "white";
      ctx.font = aS;
      ctx.fillText(aR, 0, 0);
      ctx.restore();
    }
  }
  (function (aW) {
    overlay.rainbow.val += aW * 0.3;
    if (overlay.rainbow.val >= 360) {
      overlay.rainbow.val = 0;
    }
    overlay.rainbow.upd -= aW;
    if (overlay.rainbow.upd <= 0) {
      overlay.rainbow.upd = overlay.rainbow.freq;
      overlay.rainbow.col = UTILS.hexFromHue(Math.round(overlay.rainbow.val));
    }
  })(deltaMs);
  if (!aA && OVERLAY.nametagOpacity > 0) {
    for (aE = 0; aE < Game.players.list.length; ++aE) {
      if (
        !(U = Game.players.list[aE]).active ||
        (Game.controls && Game.controls.spect.target == U)
      ) {
        continue;
      }
      if (U.isYou || !U.objInstances) {
        continue;
      }
      if (!U.isSpectating) {
        continue;
      }
      (aM = U.objInstances.position.clone()).y +=
        config.playerHeight +
        config.nameOffset -
        U.crouchVal * config.crouchDst;
      if (U.hatIndex >= 0) {
        aM.y += config.nameOffsetHat;
      }
      if (
        !(aJ =
          (aO = Math.max(
            0.3,
            1 - UTILS.getD3D(aC.x, aC.y, aC.z, aM.x, aM.y, aM.z) / 600,
          )) *
            20 >=
            1 && RENDER.frustum.containsPoint(aM))
      ) {
        continue;
      }
      ctx.save(1);
      ctx.globalAlpha = OVERLAY.nametagOpacity;
      aM.project(RENDER.camera);
      aM.x = (aM.x + 1) / 2;
      aM.y = (aM.y + 1) / 2;
      ctx.translate(ay * aM.x, az * (1 - aM.y));
      ctx.scale(aO, aO);
      let aW = overlay.nametagStyle == 1 ? 6 : 16;
      if (overlay.nametagStyle == 0 || overlay.nametagStyle == 3) {
        ctx.fillStyle = "rgba(0, 0, 0, 0.4)";
        ctx.fillRect(-65, -aW, 130, aW);
        if (OVERLAY.dynamicHP && U.hpChase > U.health / U.maxHealth) {
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(-65, -aW, U.hpChase * 130, aW);
        }
        ctx.fillStyle = aa(
          aD == U.team || (Game.mode && Game.mode.fakeNames && aD != 2)
            ? OVERLAY.healthColT
            : OVERLAY.healthColE,
        );
        ctx.fillRect(-65, -aW, (U.health / U.maxHealth) * 130, aW);
        if (overlay.healthNum) {
          ctx.save(1);
          ctx.globalAlpha = OVERLAY.nametagOpacity;
          ctx.fillStyle = "white";
          ctx.font = "9px GameFont";
          ctx.fillText(U.health, -63, -3);
          ctx.restore();
        }
      }
      if (overlay.nametagStyle < 3) {
        let aX = overlay.hideNames
          ? "Player " + U.sid
          : U.premiumT
            ? U.alias
            : U.name;
        let aY = overlay.hideNames ? null : U.clan ? "[" + U.clan + "]" : null;
        let aZ = U.level;
        var aH = COLORS.getChallCol(U.challLvl);
        var aI = COLORS.getClanCol(U.clan, U.clanR, null);
        let b0 = U.featured ? "check_circle" : null;
        let b1 = U.premiumT ? "beenhere" : null;
        let b2 = U.partner ? "verified" : null;
        let b3 = !!U.virus;
        let b4 = (premiumFont = "26px 'Material Icons'");
        ctx.font = "16px GameFont";
        let b5 = aZ && overlay.nametagStyle != 1 ? ctx.measureText(aZ).width : 0;
        ctx.font = b4;
        if (b0) {
          ctx.measureText(b0).width;
        }
        let b6 = b1 ? ctx.measureText(b1).width : 0;
        let b7 = b2 ? ctx.measureText(b2).width : 0;
        ctx.font = "20px GameFont";
        let b8 =
          ctx.measureText(aX).width + (aY || b0 || b1 || b2 || b3 ? 5 : 0);
        let b9 = aY
          ? ctx.measureText(aY).width + (b0 || b1 || b2 || b3 ? 3 : 0)
          : 0;
        ctx.translate(0, -aW - 10);
        if (aZ && overlay.nametagStyle != 1) {
          ctx.font = "16px GameFont";
          ctx.fillStyle = "rgba(0, 0, 0, 0.65)";
          ctx.fillRect(-65 - b5 - 18, -28, b5 + 18, 30);
          ctx.fillStyle = aH;
          ctx.fillText(aZ, -65 - b5 - 9, -3);
        }
        ctx.fillStyle =
          OVERLAY.kpdData && OVERLAY.kpdData == U.id ? "#eb5656" : "white";
        ctx.font = "20px GameFont";
        ctx.globalAlpha = OVERLAY.nametagOpacity;
        ctx.fillText(aX, (b5 ? 5 : 0) - 65, 0);
        ctx.globalAlpha = (aI ? 1 : 0.4) * OVERLAY.nametagOpacity;
        ctx.fillStyle = aI
          ? aI == "rgb" || U.clanR == 1
            ? OVERLAY.rainbow.col
            : aI
          : "white";
        if (aY) {
          ctx.fillText(aY, (b5 ? 5 : 0) - 65 + b8, 0);
        }
        if (voiceStreamQueues && voiceStreamQueues[aX] && voiceStreamQueues[aX].length) {
          ctx.globalAlpha = OVERLAY.nametagOpacity;
          ctx.font = "55px 'Material Icons'";
          ctx.fillStyle = "#FFF";
          ctx.fillText(ai[ag], -25, -25);
        }
        ctx.globalAlpha = OVERLAY.nametagOpacity;
        ctx.font = premiumFont;
        ctx.fillStyle = COLORS.partner;
        if (b2) {
          ctx.fillText(b2, (b5 ? 5 : 0) - 65 + b8 + b9, 1);
        }
        ctx.globalAlpha = OVERLAY.nametagOpacity;
        ctx.font = premiumFont;
        ctx.fillStyle = COLORS.verified.clan;
        if (b1) {
          ctx.fillText(b1, (b5 ? 5 : 0) - 65 + b8 + b9 + b7 + 1, 1);
        }
        ctx.globalAlpha = OVERLAY.nametagOpacity;
        ctx.font = b4;
        ctx.fillStyle = COLORS.verified.player;
        if (b0) {
          ctx.fillText(b0, (b5 ? 5 : 0) - 65 + b8 + b9 + b7 + 1 + b6 + 1, 0);
        }
      }
      ctx.restore();
    }
  }
  if (Game.mode && Game.mode.flags && aB && Game.map.manager.flags.length > 0) {
    for (aE = 0; aE < Game.map.manager.flags.length; ++aE) {
      U = Game.map.manager.flags[aE];
      if (!UTILS.pointInBox3D(aC.x, aC.y, aC.z, U.img)) {
        pos.set(U.img.x, U.img.y + 7, U.img.z);
        var aJ =
          (aP =
            (aO = Math.max(
              0.3,
              1 - UTILS.getD3D(aC.x, aC.y, aC.z, pos.x, pos.y, pos.z) / 600,
            )) * 70) >= 1 && RENDER.frustum.containsPoint(pos);
        var aK = a3[U.team == aD ? 1 : 0];
        if (aJ && aK.loaded) {
          pos.project(RENDER.camera);
          pos.x = (pos.x + 1) / 2;
          pos.y = (pos.y + 1) / 2;
          let ba = aP / aK.image.width;
          ctx.save(1);
          ctx.translate(pos.x * ay, (1 - pos.y) * az);
          ctx.scale(ba, ba);
          ctx.drawImage(aK.image, -aK.image.width / 2, -aK.image.height / 2);
          ctx.restore();
        }
      }
    }
  }
  if (
    Game.mode &&
    Game.mode.objective &&
    aB &&
    Game.map.manager.objectives.length > 0
  ) {
    var aL = true;
    var aM = Game.map.manager.objectives[Game.activeObjective];
    for (aE = 0; aE < Game.map.manager.objectives.length; ++aE) {
      U = Game.map.manager.objectives[aE];
      if (aE == Game.activeObjective && UTILS.pointInBox3D(aC.x, aC.y, aC.z, U)) {
        aL = false;
        break;
      }
    }
    if (aM && aL) {
      pos.set(aM.x, aM.y + 7, aM.z);
      if (
        (aJ =
          (aP =
            (aO = Math.max(
              0.3,
              1 - UTILS.getD3D(aC.x, aC.y, aC.z, pos.x, pos.y, pos.z) / 600,
            )) * 70) >= 1 && RENDER.frustum.containsPoint(pos)) &&
        objectiveMarkerLoaded
      ) {
        pos.project(RENDER.camera);
        pos.x = (pos.x + 1) / 2;
        pos.y = (pos.y + 1) / 2;
        let bb = aP / objectiveMarkerImage.width;
        ctx.save(1);
        ctx.translate(pos.x * ay, (1 - pos.y) * az);
        ctx.scale(bb, bb);
        ctx.drawImage(objectiveMarkerImage, -objectiveMarkerImage.width / 2, -objectiveMarkerImage.height / 2);
        ctx.restore();
      }
    }
  }
  if (Game.mode && Game.mode.site && aB && Game.map.manager.sites.length > 0) {
    for (aE = 0; aE < Game.map.manager.sites.length; ++aE) {
      U = Game.map.manager.sites[aE];
      if (!UTILS.pointInBox3D(aC.x, aC.y, aC.z, U)) {
        pos.set(U.x, U.y + 7, U.z);
        aJ =
          (aP =
            (aO = Math.max(
              0.3,
              1 - UTILS.getD3D(aC.x, aC.y, aC.z, pos.x, pos.y, pos.z) / 600,
            )) * 40) >= 1 && RENDER.frustum.containsPoint(pos);
        var aN = String.fromCharCode(65 + aE);
        if (aJ) {
          pos.project(RENDER.camera);
          pos.x = (pos.x + 1) / 2;
          pos.y = (pos.y + 1) / 2;
          let bc = aP / 50;
          ctx.save(1);
          ctx.translate(pos.x * ay, (1 - pos.y) * az);
          ctx.scale(bc, bc);
          ctx.fillStyle = "#FBC02D";
          ctx.font = "50px GameFont";
          ctx.globalAlpha = 1;
          ctx.strokeStyle = "#2e2e2e";
          ctx.lineWidth = 4;
          ctx.strokeText(aN, -24, -25);
          ctx.fillText(aN, -25, -25);
          ctx.restore();
        }
      }
    }
    for (aE = 0; aE < Game.map.manager.pickups.length; ++aE) {
      U = Game.map.manager.pickups[aE];
      if (
        aD == 2 &&
        U.pickup == 17 &&
        !UTILS.pointInBox3D(aC.x, aC.y, aC.z, U)
      ) {
        var aO;
        var aP;
        pos.set(U.x, U.y + 4, U.z);
        if (
          (aJ =
            (aP =
              (aO = Math.max(
                0.3,
                1 - UTILS.getD3D(aC.x, aC.y, aC.z, pos.x, pos.y, pos.z) / 600,
              )) * 40) >= 1 && RENDER.frustum.containsPoint(pos))
        ) {
          pos.project(RENDER.camera);
          pos.x = (pos.x + 1) / 2;
          pos.y = (pos.y + 1) / 2;
          let bd = aP / 50;
          ctx.save(1);
          ctx.translate(pos.x * ay, (1 - pos.y) * az);
          ctx.scale(bd, bd);
          ctx.fillStyle = "#FBC02D";
          ctx.font = "50px 'Material Icons'";
          ctx.globalAlpha = 1;
          ctx.strokeStyle = "#2e2e2e";
          ctx.lineWidth = 3;
          ctx.strokeText("warning", -24, -25);
          ctx.fillText("warning", -25, -25);
          ctx.restore();
        }
      }
    }
  }
  if (aB) {
    (function (be, bf, bg, bh, bi, bj) {
      if (overlay.speedDisplay.display) {
        overlay.speedDisplay.update -= bh;
        if (overlay.speedDisplay.update <= 0) {
          var bk = 0;
          overlay.speedDisplay.update = 100;
          if (bj && bj.active && !bi.moveLock) {
            bk = UTILS.getD3D(0, 0, 0, bj.velX, bj.velY, bj.velZ);
          }
          var bl = Math.round(bk * 1000);
          if (bl > ac) {
            ac = bl;
          }
          ab = bl;
        }
        be.save(1);
        be.globalAlpha = overlay.speedDisplay.opacity;
        be.translate(
          UTILS.calcPercent(bf, overlay.speedDisplay.left),
          UTILS.isNumber(overlay.speedDisplay.top)
            ? UTILS.calcPercent(bg, overlay.speedDisplay.top)
            : +overlay.speedDisplay.top.replace("px", ""),
        );
        be.font = overlay.speedDisplay.fontSize + "px GameFont";
        be.textBaseline = "middle";
        let bm = be.measureText(ab).width;
        let bn = be.measureText(ac).width;
        let bo = bm + bn + 5;
        be.fillStyle = aa(overlay.speedDisplay.color);
        be.fillText(ab + "", 0 - bo / 2, 0);
        be.fillStyle = aa(overlay.speedDisplay.colorMax);
        be.fillText(ac + "", 0 + bo / 2 - bn, 0);
        be.restore();
      }
    })(ctx, ay, az, deltaMs, Game, player);
  }
  if (Game.controls.camType.isNormal) {
    if (OVERLAY.showFlash && flashLoaded) {
      let be = ay * 1.6;
      ctx.drawImage(
        flashImage,
        ay * OVERLAY.flashX - be / 2,
        az * OVERLAY.flashY - be / 2,
        be,
        be,
      );
    }
    if (aB) {
      if (OVERLAY.fakeCross) {
        if (
          newLeaderDisplay.style.display !== "inline-block" &&
          terminalHolder.style.display !== "inline-block" &&
          aimRecticle.style.opacity != 1 &&
          RENDER.aimRecticle.opacity != 1
        ) {
          ctx.save(1);
          ctx.translate(ay / 2, az / 2);
          ao(ctx, 2, 4, 1, 1, 90);
          ao(ctx, 2, 4, 1, 1, -90);
          ao(ctx, 2, 4, 1, 1, 0);
          ao(ctx, 2, 4, 1, 1, 180);
          ctx.restore();
        }
      } else if (
        OVERLAY.crosshairType > 0 &&
        !window.spectating &&
        newLeaderDisplay.style.display !== "inline-block"
      ) {
        let bf = OVERLAY.crosshairScale;
        let bg = ay / 2;
        let bh = az / 2;
        let bi = bg - bf / 2;
        let bj = bh - bf / 2;
        let bk = 4;
        let bl = 21;
        let bm = OVERLAY.crosshairThick;
        let bn = OVERLAY.crosshairLen;
        let bo = OVERLAY.crosshairOpacity;
        if (OVERLAY.crosshairType > 1 && OVERLAY.crosshairAlways) {
          bo = 1;
        }
        if (OVERLAY.crosshairType > 1 && OVERLAY.crosshairUseOpacityCustom) {
          bo = OVERLAY.crosshairOpacityCustom;
        }
        if (bo) {
          ctx.save(1);
          ctx.globalAlpha = bo;
          if (OVERLAY.crosshairType == 4) {
            ctx.translate(0, 0);
            ctx.beginPath();
            ctx.drawImage(
              OVERLAY.crosshairImage,
              bg - OVERLAY.crosshairImage.width / 2,
              bh - OVERLAY.crosshairImage.height / 2,
            );
          } else if (OVERLAY.crosshairType == 2 || OVERLAY.crosshairType == 3) {
            if (OVERLAY.crosshairStyle == 0) {
              an(
                ctx,
                bg - bm * 0.5,
                bh - bn,
                bm,
                bn * 2,
                1,
                false,
                OVERLAY.crosshairShadowThickness,
              );
              an(
                ctx,
                bg - bn,
                bh - bm / 2,
                bn * 2,
                bm,
                1,
                false,
                OVERLAY.crosshairShadowThickness,
              );
              an(ctx, bg - bm * 0.5, bh - bn, bm, bn * 2, 1, false, false);
            } else if (OVERLAY.crosshairStyle > 0) {
              an(
                ctx,
                bg - (bn * 2) / 2,
                bh - (bn * 2) / 2,
                bn * 2,
                bn * 2,
                bm / 2,
                OVERLAY.crosshairStyle == 1 || OVERLAY.crosshairStyle == 2,
                OVERLAY.crosshairShadowThickness,
                OVERLAY.crosshairStyle == 2 || OVERLAY.crosshairStyle == 4,
              );
            }
          } else if (OVERLAY.crosshairType == 5) {
            ctx.translate(bg, bh);
            if (OVERLAY.crosshairDot) {
              ao(ctx, bm, null, null, null, null, true);
            }
            ao(
              ctx,
              bm,
              bn,
              OVERLAY.crosshairGap,
              OVERLAY.crosshairShadowThickness,
              90,
            );
            ao(
              ctx,
              bm,
              bn,
              OVERLAY.crosshairGap,
              OVERLAY.crosshairShadowThickness,
              -90,
            );
            ao(
              ctx,
              bm,
              bn,
              OVERLAY.crosshairGap,
              OVERLAY.crosshairShadowThickness,
              0,
            );
            ao(
              ctx,
              bm,
              bn,
              OVERLAY.crosshairGap,
              OVERLAY.crosshairShadowThickness,
              180,
            );
          }
          if (OVERLAY.crosshairType == 1 || OVERLAY.crosshairType == 3) {
            ctx.globalAlpha = OVERLAY.crosshairOpacity;
            an(
              ctx,
              bi,
              bj + bf / 2 - bk / 2,
              bl,
              bk,
              1,
              false,
              OVERLAY.crosshairShadowThickness,
            );
            an(
              ctx,
              bi + bf - bl,
              bj + bf / 2 - bk / 2,
              bl,
              bk,
              1,
              false,
              OVERLAY.crosshairShadowThickness,
            );
            an(
              ctx,
              bi + bf / 2 - bk / 2,
              bj,
              bk,
              bl,
              1,
              false,
              OVERLAY.crosshairShadowThickness,
            );
            an(
              ctx,
              bi + bf / 2 - bk / 2,
              bj + bf - bl,
              bk,
              bl,
              1,
              false,
              OVERLAY.crosshairShadowThickness,
            );
          }
          ctx.restore();
        } else if (player && player.aimVal == 0 && player.canThrow && player.weapon.canThrow) {
          ctx.save(1);
          ctx.translate(bg, bh);
          ao(ctx, 3, null, null, OVERLAY.crosshairShadowThickness, null, true);
          ao(ctx, 3, bn * 0.8, 14, OVERLAY.crosshairShadowThickness, 90);
          ao(ctx, 3, bn * 0.8, 14, OVERLAY.crosshairShadowThickness, -90);
          ao(ctx, 3, bn * 1.5, 14, OVERLAY.crosshairShadowThickness, 0);
          ao(ctx, 3, bn * 1.5, 15, OVERLAY.crosshairShadowThickness, 180);
          ctx.restore();
        }
      }
    }
  }
  if (OVERLAY.drawMinimap) {
    ctx.save(1);
    ctx.fillStyle = "rgba(0,0,0,0.5)";
    ctx.translate(200, 200);
    ctx.fillRect(-175, -175, 350, 350);
    for (aE = 0; aE < Game.players.list.length; ++aE) {
      if ((U = Game.players.list[aE]).active && U.objInstances) {
        (aM = U.objInstances.position.clone()).x -= Game.map.mapDims.cX;
        aM.x *= Game.map.mapDims.sX;
        aM.z -= Game.map.mapDims.cZ;
        aM.z *= Game.map.mapDims.sZ;
        aM.x = UTILS.limit(aM.x, 175);
        aM.z = UTILS.limit(aM.z, 175);
        ctx.fillStyle = "#ff00ff";
        ctx.fillRect(aM.x - 2, aM.z - 2, 4, 4);
      }
    }
    ctx.restore();
  }
  if (
    !OVERLAY.bloodCustom &&
    OVERLAY.bloodOpacity > 0 &&
    OVERLAY.bloodLoaded &&
    !aA
  ) {
    ctx.save(1);
    ctx.globalAlpha = OVERLAY.bloodOpacity;
    ctx.drawImage(OVERLAY.bloodImage, 0, 0, ay, az);
    ctx.restore();
  }
  if (
    !RENDER.aimRecticle.custom &&
    RENDER.aimRecticle.opacity > 0 &&
    RENDER.aimRecticle.loaded
  ) {
    ctx.save(1);
    ctx.globalAlpha = 1;
    if (OVERLAY.scopeBorders) {
      ctx.beginPath();
      ctx.fillStyle = "#000000";
      ctx.rect(0, 0, ay, az / 2 - RENDER.aimRecticle.height / 2 + 2);
      ctx.rect(
        0,
        az / 2 + RENDER.aimRecticle.height / 2 - 2,
        ay,
        az - az / 2 + RENDER.aimRecticle.height / 2 + 2,
      );
      ctx.rect(0, 0, ay / 2 - RENDER.aimRecticle.width / 2 + 2, az);
      ctx.rect(
        ay / 2 + RENDER.aimRecticle.width / 2 - 2,
        0,
        ay - (ay / 2 + RENDER.aimRecticle.width / 2) + 2,
        az,
      );
      ctx.fill();
    }
    ctx.drawImage(
      RENDER.aimRecticle.image,
      ay / 2 - RENDER.aimRecticle.width / 2,
      az / 2 - RENDER.aimRecticle.height / 2,
      RENDER.aimRecticle.width,
      RENDER.aimRecticle.height,
    );
    ctx.restore();
  }
  if (
    !RENDER.aimDot.custom &&
    RENDER.aimDot.display &&
    RENDER.aimDot.opacity > 0 &&
    RENDER.aimDot.loaded
  ) {
    ctx.save(1);
    ctx.globalAlpha = 1;
    ctx.drawImage(
      RENDER.aimDot.image,
      ay / 2 - RENDER.aimDot.width / 2,
      az / 2 - RENDER.aimDot.height / 2,
      RENDER.aimDot.width,
      RENDER.aimDot.height,
    );
    ctx.restore();
  }
  (function (bp, bq, br, bs) {
    if (a8.active) {
      if (
        a8.opacity > 0 &&
        ((a8.spacing += overlay.hitSet.inc * bs),
        (a8.inc -= overlay.hitSet.speed * bs),
        (a8.opacity -= overlay.hitSet.fadeOut * bs),
        (a8.opacity = Math.max(a8.opacity, 0)),
        a8.opacity <= 0)
      ) {
        a8.active = false;
      } else {
        bp.save(1);
        bp.translate(bq / 2, br / 2);
        bp.rotate(Math.PI / 4);
        bp.globalAlpha = a8.opacity;
        a9(
          bp,
          -overlay.hitSet.thickness / 2,
          -a8.length / 2 - a8.spacing,
          overlay.hitSet.thickness,
          a8.length,
          "Y",
          a8.colors[0],
        );
        a9(
          bp,
          -overlay.hitSet.thickness / 2,
          -a8.length / 2 + a8.spacing,
          overlay.hitSet.thickness,
          a8.length,
          "Y",
          a8.colors[1],
        );
        a9(
          bp,
          -a8.length / 2 - a8.spacing,
          -overlay.hitSet.thickness / 2,
          a8.length,
          overlay.hitSet.thickness,
          "X",
          a8.colors[0],
        );
        a9(
          bp,
          -a8.length / 2 + a8.spacing,
          -overlay.hitSet.thickness / 2,
          a8.length,
          overlay.hitSet.thickness,
          "X",
          a8.colors[1],
        );
        bp.restore();
      }
    }
  })(ctx, ay, az, deltaMs);
  for (aE = OVERLAY.divs.length - 1; aE >= 0; --aE) {
    if ((U = OVERLAY.divs[aE]).life >= 0 && U.display && !U.disabled && aB) {
      ctx.save(1);
      ctx.globalAlpha = U.opacity;
      if (U.text) {
        ctx.translate(
          UTILS.calcPercent(ay, U.left),
          UTILS.isNumber(U.top)
            ? UTILS.calcPercent(az, U.top)
            : +U.top.replace("px", ""),
        );
        if (U.rect) {
          ctx.fillStyle = U.rect.color;
          ctx.fillRect(0 - U.width / 2, 0, U.width, U.height);
        }
        ctx.font = U.fontSize + "px GameFont";
        ctx.textBaseline = "middle";
        if (U.textAlign) {
          ctx.textAlign = U.textAlign;
        }
        if (U.shadow) {
          ctx.strokeStyle = "black";
          ctx.lineWidth = U.shadow;
          ctx.strokeText(U.text, 1, 0 + (U.lineHeight ? U.lineHeight / 2 : 0));
        }
        ctx.fillStyle = U.color;
        ctx.fillText(U.text, 0, 0 + (U.lineHeight ? U.lineHeight / 2 : 0));
        if (U.text2) {
          ctx.font = "34px GameFont";
          ctx.textBaseline = "middle";
          if (U.textAlign) {
            ctx.textAlign = U.textAlign;
          }
          ctx.fillStyle = OVERLAY.scoreText.color;
          ctx.fillText(U.text2, 0, U.height - 26);
        }
      } else if (U.image && U.loaded && !U.custom) {
        ctx.drawImage(
          U.image,
          ay / 2 - U.width / 2,
          az / 2 - U.height / 2,
          U.width,
          U.height,
        );
      }
      ctx.restore();
    }
    if (U.delay > 0) {
      U.delay -= deltaMs;
      if (U.delay <= 0) {
        U.display = true;
      }
    } else {
      if (U.scale > U.minScale) {
        U.scale -= U.scaleSpeed * deltaMs;
        if (U.scale <= U.minScale) {
          U.scale = U.minScale;
        }
        U.fontSize = U.scale;
      }
      if (U.scaleSpd) {
        U.startS += U.scaleSpd * deltaMs;
        U.width = U.startS;
        U.height = U.startS;
      }
      U.life -= deltaMs;
      if (U.life <= 0) {
        U.display = false;
        var aQ = U.callback;
        OVERLAY.divs.splice(aE, 1);
        if (aQ) {
          aQ();
        }
      }
      if (U.fade && U.life <= U.fade) {
        U.opacity = U.life / U.fade;
      }
    }
  }
  U = overlay.vicTitle;
  if (endUI.style.display != "none" && U.show) {
    let bp = unscaledDeltaMs / 16;
    ctx.save(1);
    ctx.globalAlpha = U.opacity.val;
    U.opacity.val += U.opacity.increment * bp;
    ctx.fillStyle = "rgba(0, 0, 0, 0.33)";
    ctx.fillRect(0, 0, ay, az);
    let bq = a4[overlay.vicTitle.type];
    if (bq.loaded) {
      let br = bq.img.height * U.scale.val;
      let bs = bq.img.width * U.scale.val;
      ctx.drawImage(bq.img, (ay - bs) / 2, (az - br) / 2, bs, br);
    }
    U.scale.val -= U.scale.decrement * bp;
    U.scale.val = Math.max(1, U.scale.val);
    U.scale.decrement += U.scale.acc * bp;
    ctx.restore();
  } else {
    if (U.opacity.val != 0) {
      U.opacity.val = 0;
    }
    if (U.scale.val != 2) {
      U.scale.val = 2.5;
    }
    if (U.scale.decrement != 0.01) {
      U.scale.decrement = 0.01;
    }
  }
  OVERLAY.fakeCross = false;
  ctx.restore();
};
function ao(ap, aq, ar, as, at, au, av) {
  ap.save(1);
  ap.fillStyle = overlay.crosshairColor;
  if (at && !av) {
    ap.strokeStyle = overlay.crosshairShadow;
  }
  ap.lineWidth = 1;
  as = (function (aw) {
    return aw * 1 + 3;
  })(as);
  aq = (function (aw) {
    return (aw / 10) * 19;
  })(aq);
  ar =
    (function (aw) {
      return (aw / 10) * 19;
    })(ar) * -1;
  ap.beginPath();
  if (!av) {
    ap.rotate(((au || 0) * Math.PI) / 180);
  }
  ap.rect(-aq / 2, -(aq / 2 + (av ? 0 : as)), aq, av ? aq : ar);
  ap.fill();
  if (at && !av) {
    ap.stroke();
  }
  ap.restore();
}
module.exports = overlay;
